module.exports = __webpack_public_path__ + "pic_bizny_web_01-375@2x.png?cec21ebc372fed9bd665747b1e61f9ad";